module.exports = __webpack_public_path__ + "img/13_uk.5cfb52be.svg";